module.exports = __webpack_public_path__ + "static/assets/3cef1ab99c9ed2f689b2dd8a091dc4cd.svg";